import styled, { css } from 'styled-components';
import { createHandler } from '@mews/std';
import { BORDER_RADIUS, Component, Decision, ELEVATION, getComponentToken, SPACING } from '@optimus-web/local-tokens';
import theme from '@optimus-web/theme';
import { Attachment, getAttachmentBorderRadius } from '../utils/attachment';
import { CardSpacing } from './cardSpacing';

type CardVariant = 'default' | 'overlay';

const getCardToken = getComponentToken(Component.Card);

const getShadow = createHandler({
    default: ELEVATION['25'],
    overlay: ELEVATION['100'],
});

export interface CardProps {
    variant?: CardVariant;
    padding?: CardSpacing;
    attachment?: Attachment;
    overflowHidden?: boolean;
}

const Card = styled.div<CardProps>`
    box-sizing: border-box;
    background: ${getCardToken(Decision.BackgroundColor)};

    ${(props) => props.padding && `padding: ${SPACING[props.padding]}px;`}
    ${(props) => props.variant && `box-shadow: ${getShadow(props.variant)};`}
    ${(props) => `border-radius: ${getAttachmentBorderRadius(props.attachment, BORDER_RADIUS[100])};`}
    ${(props) => props.overflowHidden === true && `overflow: hidden;`}
`;
Card.defaultProps = {
    variant: 'default',
    padding: '0',
    theme,
};

export default Card;

const getCardContentToken = getComponentToken(Component.CardContent);

interface CardContentProps {
    padding?: CardSpacing;
    highlighted?: boolean;
}

export const CardContent = styled.div<CardContentProps>`
    ${(props) =>
        props.padding &&
        css`
            padding: ${SPACING[props.padding]}px;
        `}
    ${(props) =>
        props.highlighted &&
        css`
            background-color: ${getCardContentToken(Decision.BackgroundColor, { variant: 'highlighted' })};
            &:not(:first-child) {
                border-top: 1px solid ${getCardContentToken(Decision.BorderColor, { variant: 'highlighted' })};
            }
            &:not(:last-child) {
                border-bottom: 1px solid ${getCardContentToken(Decision.BorderColor, { variant: 'highlighted' })};
            }
        `}
`;
